import { Box } from "@mui/material";
import { useSelector } from "react-redux";

const ExchangeIcon = ({ name, size = 40, isLink = true, compact = false }) => {
    const data = useSelector((state) => state.crypto.exchanges);
    const img = (
        <Box
            component="img"
            alt={name}
            src={data[name]?.img}
            sx={{
                width: size,
                height: size,
                objectFit: 'contain',
                display: 'block',
            }}
        />
    );

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                m: compact ? 0 : '5px',
                width: compact ? size : 'auto',
                height: compact ? size : 'auto',
                flexShrink: 0,
            }}
        >
            {isLink ? (
                <a title={name} href={data[name]?.link} target="_blank" rel="noreferrer" style={{ display: 'flex', lineHeight: 0 }}>
                    {img}
                </a>
            ) : (
                img
            )}
        </Box>
    );
};

export default ExchangeIcon;

export const EXCHANGE_TOOLBAR_ICON_SIZE = 22;
export const EXCHANGE_TOOLBAR_BTN_SIZE = 36;

export const exchangeToolbarIconBtnSx = (active) => ({
    m: 0,
    minWidth: EXCHANGE_TOOLBAR_BTN_SIZE,
    width: EXCHANGE_TOOLBAR_BTN_SIZE,
    height: EXCHANGE_TOOLBAR_BTN_SIZE,
    minHeight: EXCHANGE_TOOLBAR_BTN_SIZE,
    p: 0,
    borderRadius: 1,
    border: 'none',
    cursor: 'pointer',
    color: 'inherit',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    verticalAlign: 'middle',
    boxShadow: 'none',
    backgroundColor: active ? 'primary.light' : 'transparent',
    transition: 'background-color 0.15s ease',
    '&:hover': {
        backgroundColor: active ? 'primary.light' : 'rgba(255,255,255,0.08)',
        boxShadow: 'none',
    },
    '&:focus': {
        outline: 'none',
        backgroundColor: active ? 'primary.light' : 'transparent',
        boxShadow: 'none',
    },
    '&:focus-visible': {
        outline: '1px solid rgba(149, 242, 5, 0.45)',
        backgroundColor: active ? 'primary.light' : 'transparent',
        boxShadow: 'none',
    },
    '&:active': {
        backgroundColor: active ? 'primary.light' : 'rgba(255,255,255,0.08)',
        boxShadow: 'none',
    },
});

export const exchangeToolbarBtnSx = exchangeToolbarIconBtnSx;
